<template>
  <div class="anniversary-page">
    <div v-wechat-title="'新春开局，胜天半子'"></div>

    <!-- 登录弹窗 -->
    <Login
      v-if="isShowLogin"
      :gameName="gameName"
      :downloadUrl="downloadUrl"
      :loginTypes="loginTypes"
      channelTips="角色UID可在游戏中—设置—UID查看"
      :autoOpenOS="true"
      @loginSuccess="loginSuccess"
      @selectCallback="loginCallback"
      noAuthLogin
    ></Login>
    <Os
      v-if="isShowOs"
      v-on:logoutCallback="osCancell"
      @noRole="noRole"
      @getSelectInfo="getSelectInfo"
      :gameName="gameName"
    ></Os>
    <!-- 头部 -->
    <Header
      v-if="true"
      :config="headerConfig"
      :downloadApp="downloadApp"
      :isShowInfo="true"
      :isOnline="1"
      @reInit="reInit"
    />

    <!-- 首页 -->
    <div class="active-page">
      <div class="section-container">
        <div class="section section1">
          <div class="banner-bg"></div>
          <div class="banner"></div>
          <div class="book-box">
            <div
              class="appoint-btn"
              :class="buttonClass"
              @click="appoint()"
            ></div>
          </div>
          <div class="version-box">
            <div class="title-box">
              <div class="ys_title" @click="changeActive(0)">
                <div class="qtn" v-show="active === 0"></div>
              </div>
              <div class="qs_title" @click="changeActive(1)">
                <div class="jz" v-show="active === 1"></div>
              </div>
            </div>
            <div
              :class="
                active === 0
                  ? 'chessboard chessboard-left'
                  : 'chessboard chessboard-right'
              "
            ></div>
            <div
              :class="active === 0 ? 'pieces_bg' : 'pieces_bg unactive-left'"
            >
              <div class="white_pieces"></div>
              <div
                class="class-wrap"
                v-if="active === 1"
                @click="changeActive(0)"
              ></div>
              <div
                :class="
                  active === 0
                    ? 'special_effects'
                    : 'special_effects opacity_unactive'
                "
              ></div>
              <div class="zw"></div>
              <div
                :class="
                  active === 0 ? 'zw_subtitle' : 'zw_subtitle opacity_unactive'
                "
              ></div>
              <div
                :class="
                  active === 0
                    ? 'zw_discourse'
                    : 'zw_discourse opacity_unactive'
                "
              ></div>
            </div>
            <div
              :class="active === 1 ? 'pieces_bg1' : 'pieces_bg1 unactive-right'"
            >
              <div class="black_chessman"></div>
              <div
                class="class-wrap"
                v-if="active === 0"
                @click="changeActive(1)"
              ></div>
              <div
                :class="
                  active === 1
                    ? 'special_effects'
                    : 'special_effects opacity_unactive'
                "
              ></div>
              <div class="qs"></div>
              <div
                :class="
                  active === 1 ? 'qs_subtitle' : 'qs_subtitle opacity_unactive'
                "
              ></div>
              <div
                :class="
                  active === 1
                    ? 'qs_discourse'
                    : 'qs_discourse opacity_unactive'
                "
              ></div>
            </div>
          </div>
          <div class="welfare-box"></div>
        </div>
      </div>
    </div>

    <!-- 新服预约——角色二次确认弹窗 -->
    <div
      class="team-bind-role-confirm-wrap popup_wrap"
      v-show="teamBindRoleConfirmShow"
    >
      <transition
        enter-active-class="animated zoomInNew"
        leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }"
      >
        <div
          class="team-bind-role-confirm-box popup_wrap-box"
          v-show="teamBindRoleConfirmShow"
        >
          <div class="tips">
            <p>[{{ selectedRoleInfo.server_name }}]</p>
            <p class="name">{{ selectedRoleInfo.role_name }}</p>
          </div>
          <div class="btn-box">
            <div
              class="btn cancel-btn"
              data-snail-report-name="新服预约-二次取消绑定角色"
              @click="closeReConfirmBindRole()"
            ></div>
            <div
              class="btn confirm-btn"
              data-snail-report-name="新服预约-二次确认绑定角色"
              @click="confirmBindRole()"
            ></div>
          </div>
        </div>
      </transition>
    </div>

    <!-- 角色选择 -->
    <div class="snail-role-select-wrap popup_wrap" v-show="snailRoleSelect">
      <transition
        enter-active-class="animated zoomInNew"
        leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }"
      >
        <div
          class="snail-role-select-box popup_wrap-box"
          v-show="snailRoleSelect"
        >
          <div class="option-box">
            <div class="input">
              <select
                v-model="selectedRoleID"
                @focus="inputFocus()"
                @focusout="inputFocusOut()"
              >
                <option value="">请选择区组</option>
                <option
                  v-for="(item, index) in roleList"
                  :key="index"
                  :value="item.role_id"
                >
                  <span>{{
                    "区服:" +
                    item.server_name +
                    " 综合实力:" +
                    (item.extra && item.extra.score)
                  }}</span>
                </option>
              </select>
            </div>
            <div class="input input-name">
              <input
                type="text"
                name=""
                readonly
                v-model="roleName"
                placeholder="请选择角色"
                @focus="inputFocus()"
                @focusout="inputFocusOut()"
              />
            </div>
          </div>
          <div class="btn-box">
            <div
              class="cancel-btn"
              data-snail-report-name="新服预约-取消绑定角色"
              @click="closePopup('snailRoleSelect')"
            ></div>
            <div
              class="confirm-btn"
              data-snail-report-name="新服预约-确认绑定角色"
              @click="reConfirmBindRolePopup()"
            ></div>
          </div>
        </div>
      </transition>
    </div>

    <!-- 预约成功弹窗 -->
    <div class="appoint-success-pop popup_wrap" v-show="appointSuccessShow">
      <transition
        enter-active-class="animated zoomInNew"
        leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }"
      >
        <div class="success-box popup_wrap-box" v-show="appointSuccessShow">
          <div :class="userInfo.game_id === 26 ? 'title1' : 'title2'"></div>
          <div class="confirm-btn" @click="closeAppointPop()"></div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { Toast, Indicator } from "mint-ui";
import { mapState, mapMutations, mapActions } from "vuex";
import { GetRoleList } from "@/api/os";
import Os from "../os";
import Login from "@/components/login";
import Header from "../Header/index.vue";
import Footer from "@/components/Footer";
import { APP_ID, PAGE_ID, GAME_AREA } from "@/config/constant";
import { headerConfig } from "../headerConfig";
import { onGetInitDataAPI, appointAPI, teamRewardAPI } from "../api";
import { getRandomString } from "@/utils/utils";

export default {
  name: "recall",
  components: {
    Header,
    Footer,
    Login,
    Os,
  },
  props: {
    downloadApp: {
      type: Function,
      default: () => {
        return () => {};
      },
    },
    logger: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      headerConfig,
      gameName: "snail",
      account: null,
      user_id: null,
      server_name: "",
      downloadUrl: "http://snail.qingcigame.com/official/",
      loginTypes: ["sms", "password"],
      isBook: false,
      isRewardStart: false,
      isBookSend: false,

      // 弹窗
      preventShow: false, // 全局遮罩
      appointSuccessShow: false, // 预约成功弹窗
      teamBindRoleConfirmShow: false, // 组队消费——绑定角色确认弹窗
      snailRoleSelect: false, // 角色选择

      selectedRoleInfo: {},
      roleList: [],
      selectedRoleID: "",
      active: 0,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.isSetShare();
      this.getLoginContainer();
    });
  },
  computed: {
    buttonClass() {
      if (this.isBook) {
        if (this.isRewardStart && !this.isBookSend) {
          return "btn-receive";
        } else if (this.isRewardStart && this.isBookSend) {
          return "btn-received";
        } else {
          return "btn-appointed";
        }
      } else {
        return "btn-book";
      }
    },
    roleName() {
      // 当区组为空时, 角色名为空
      let roleName =
        this.selectedRoleID && this.roleList.length > 0
          ? this.roleList.find((item) => item.role_id === this.selectedRoleID)
              .role_name
          : "";
      return roleName;
    },
    ...mapState(["userInfo", "activeInfo", "isShowLogin", "isShowOs"]),
  },
  watch: {
    userInfo: {
      handler(newValue, oldValue) {
        if (oldValue.account) {
          if (newValue.account !== oldValue.account) {
            if (!newValue.account) {
              // TAG: 注销的时候
              this.reInit();
            } else {
              // console.log('登录成功');
              this.getLoginContainer();
            }
          }
        }
      },
    },
    logger: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.logger.sum("马年专题_新服预约页");
        }
      },
    },
  },
  methods: {
    changeActive(index) {
      this.active = index;
      if (index === 0) {
        this.logger.sum("马年专题_新服预约页_纣王白子	");
      } else {
        this.logger.sum("马年专题_新服预约页_六耳猕猴黑子");
      }
    },
    // 初始化
    getLoginContainer() {
      onGetInitDataAPI().then((response) => {
        if (response.code == 403) {
          this.setUserInfo({});
          this.onToast(response.message);
        }
        if (response.code == 401) {
          this.onInitDataCallback({
            ...response,
            needAccount: true,
          });
        }
        if (Number(response.code) == 200) {
          this.activity = response.data.activity;
          this.user_info = response.data.user_info;
          this.user_id = response.data.user_info.user_id;
          this.server_name = response.data.user_info.server_name;

          this.isBook = response.data.activity.is_book; // 是否预约
          this.isRewardStart = response.data.activity.is_reward_start; // 是否可以领取预约奖励
          this.isBookSend = response.data.activity.is_book_send; // 是否领取预约奖励

          this.onInitDataCallback(response);
          this.setUserInfo(response.data.user_info);
          this.setActiveInfo(response.data.activity);
        }
      });
    },
    noRole() {
      this.setUserInfo({});
      // this.changeOsPopup(false);
    },
    getSelectInfo(selectInfo) {
      this.selectInfo = selectInfo;
      selectInfo.account = this.userInfo.account;
      this.setUserInfo(selectInfo);
      this.getLoginContainer();
    },
    // 区组弹窗注销-相关参数复位
    osCancell() {
      // this.changeOsPopup(false);
    },
    // 预约/领奖
    appoint() {
      this.logger.sum("马年专题预约_点击预约按钮");

      // 有无登录
      if (!this.userInfo.account) {
        this.changeLoginPopup(true);
        return;
      }

      // ① 未预约 → 立即预约
      if (!this.isBook) {
        this.logger.sum("马年专题预约_立即预约");
        this.appointAward();
        return;
      }

      // ② 已预约，时间未到 → 提示“到时间再来领取奖励”
      if (this.isBook && !this.isRewardStart) {
        this.onToast("预约成功！请于2月13日5:00后在当前页面领取奖励");
        return;
      }

      // ③ 时间到了，未领奖 → 弹出领奖弹窗（如弹角色绑定）
      if (this.isBook && this.isRewardStart && !this.isBookSend) {
        if (!this.userInfo.rid) {
          // 未绑定角色 - 弹绑定弹窗
          this.onBindRolePopup();
        } else {
          this.receiveAward(); //领奖
        }
        return;
      }

      // ④ 已预约、已领奖 → 提示“你已领奖”
      if (this.isBook && this.isRewardStart && this.isBookSend) {
        this.onToast("你已领奖");
        return;
      }
    },

    // 角色选弹窗
    async onBindRolePopup() {
      if (this.userInfo.user_id === undefined) {
        this.changeLoginPopup(true);
        return;
      }

      // 获取角色信息 打开角色选择弹窗
      const roleResponse = await GetRoleList({
        account: this.userInfo.account,
        page_id: PAGE_ID[this.gameName],
        app_id: APP_ID[this.gameName],
      });

      if (Number(roleResponse.code) === 200) {
        // 获取所有区服数据
        // const roleData = roleResponse.data;

        // // 查找正式服区服角色
        // const requiredServerId = 39;

        // // 无正式服角色
        // if (!roleData.hasOwnProperty(requiredServerId)) {
        //   this.onToast("很抱歉，暂无《最强蜗牛》正式服游戏角色");
        //   return;
        // }

        let data = roleResponse.data[this.user_info.game_id];
        this.roleList = data["android"];
        this.selectedRoleID = "";
        this.selectedRoleInfo = {};
        this.showPopup("snailRoleSelect");
      }
    },
    // 角色信息二次确认弹窗
    reConfirmBindRolePopup() {
      if (this.selectedRoleID === "") {
        return this.onToast("请选择区组");
      }
      let selectInfo = this.roleList.find(
        (item) => item.role_id === this.selectedRoleID
      );
      selectInfo.type = "android";
      selectInfo.dist = APP_ID[this.gameName];
      selectInfo.extra = JSON.stringify(selectInfo.extra);
      this.selectedRoleInfo = selectInfo;
      this.closePopup("snailRoleSelect");
      this.showPopup("teamBindRoleConfirmShow");
    },
    closeReConfirmBindRole() {
      this.selectedRoleInfo = {};
      this.closePopup("teamBindRoleConfirmShow");
    },
    confirmBindRole() {
      this.onPreventShow();
      teamRewardAPI({
        ...this.selectedRoleInfo,
        is_bind: 1,
        type: 2,
      })
        .then((response) => {
          if (Number(response.code) === 200) {
            this.closePopup("teamBindRoleConfirmShow");
            this.onToast("绑定成功");
            this.getLoginContainer();
          } else {
            this.onToast(response.message);
          }
        })
        .finally(() => {
          this.onPreventClose();
        });
    },
    receiveAward() {
      teamRewardAPI({
        role_id: this.user_info.rid,
        role_name: this.user_info.role_name,
        server_id: this.user_info.server_id,
        server_name: this.user_info.server_name,
        game_id: this.user_info.game_id,
        type: 2,
      }).then((response) => {
        if (Number(response.code) === 200) {
          this.closePopup("teamBindRoleConfirmShow");
          this.onToast("领取成功");
          this.getLoginContainer();
        } else {
          this.onToast(response.message);
        }
      });
    },
    appointAward() {
      appointAPI().then((response) => {
        if (response.code == 200) {
          this.appointSuccessShow = true;
          this.logger.sum("马年专题预约_预约成功");
          this.isBook = true;
          this.getLoginContainer();
        } else {
          this.onToast(response.message);
        }
      });
    },
    // 关闭预约成功弹窗
    closeAppointPop() {
      this.appointSuccessShow = false;
    },
    showPopup(name) {
      this[name] = true;
    },
    closePopup(name) {
      this[name] = false;
    },
    inputFocus() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
    },
    inputFocusOut() {
      this.timer = setTimeout(() => {
        window.scrollTo(0, 0);
      }, 10);
    },
    // 打开遮罩
    onPreventShow() {
      Indicator.open();
      this.preventShow = true;
    },
    // 关闭遮罩
    onPreventClose() {
      Indicator.close();
      this.preventShow = false;
    },
    loginSuccess() {
      // this.getLoginContainer();
    },
    reInit() {
      // this.changeOsPopup(false);
      this.clearActiveInfo();
    },
    clearActiveInfo() {
      this.isBook = false;
      this.isDaySign = false;
      this.signCount = 0;

      this.selectedRoleInfo = {};
      this.roleList = [];

      this.setInitUserInfo();
      this.setInitActiveInfo();
    },
    loginCallback(response) {
      localStorage.setItem("mnzt_token", response.data.access_token);
    },
    onToast(config, duration) {
      const curConfig = {
        duration: duration || 1000,
        className: "toasts",
      };
      if (!config) {
        console.error("缺少config参数");
        return false;
      }
      if (typeof config === "string") {
        curConfig.message = config;
      }
      Toast(curConfig);
    },
    // 微信分享
    isSetShare() {
      this.setShare({
        link: `https://h5.qingcigame.com/snail/springFestival/anniversary${getRandomString()}`,
        title: "【最强蜗牛】蜗也要胜天半子！",
        imgUrl:
          "https://download4.qcplay.com/qcgame-api/mDG0FvkV2xtEH4cfyEIt8MMcWF6CxRo6IdrDiHzx.png",
        desc: "组队闯天局，限定绿贵轻松到手，搜寻Beter前世“马必得”的秘密宝库，入队速戳！",
      });
    },
    ...mapMutations([
      "setUserInfo",
      "setInitUserInfo",
      "setInitActiveInfo",
      "changeLoginPopup",
      "changeOsPopup",
      "setActiveInfo",
    ]),
    ...mapActions(["onInitDataCallback", "setShare"]),
  },
};
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/snail/springFestival/anniversary/index.vue